/**
 * Present when the collapsible panel is open.
 */
export const panelOpen = 'data-panel-open';